import { render, staticRenderFns } from "./AveineWinePicker.vue?vue&type=template&id=5d59e459"
import script from "./AveineWinePicker.vue?vue&type=script&lang=js"
export * from "./AveineWinePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports